<script>
  import { useForm } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FormLayout from '../../components/form_layout.svelte'
  import FormSection from '../../components/form_section.svelte'
  import TextField from '../../components/form/text_field.svelte'
  import CheckboxField from '../../components/form/checkbox_field.svelte'
  import SubmitButton from '../../components/form/submit_button.svelte'
  import { Button, Icon } from '../../components/ui'
  import { liveValidate } from '../../lib/live_validation.svelte.js'

  let { abilities = [], ability_checks = {}, can_manage_abilities = false } = $props()

  // Validation is the server's (live Precognition requests + Save).
  const form = useForm({
    admin: { name: '', email: '', ability_names: { ...ability_checks } }
  }).withPrecognition('post', '/admins/invite')
  liveValidate(form, 'admin')

  const submit = (e) => {
    e.preventDefault()
    $form.post('/admins/invite')
  }
</script>

<Layout>
  <PageHeader title="Invite Admin" subtitle="Send an invite and set what the new admin can manage" />

  <FormLayout onsubmit={submit}>
    <FormSection title="Details">
      <TextField bind:value={$form.admin.email} label="Email" name="email" error={$form.errors['admin.email']} />
      <TextField bind:value={$form.admin.name} label="Full Name" name="name" error={$form.errors['admin.name']} />
    </FormSection>

    <FormSection>
      <h2 class="font-semibold text-sm flex items-center gap-1">
        Can Manage
        {#if !can_manage_abilities}
          <span class="text-base-content/40" title="Requires the Abilities permission to set permissions">
            <Icon name="lock" size="xs" />
          </span>
        {/if}
      </h2>
      <div class="grid grid-cols-2 gap-x-4 gap-y-2" class:opacity-50={!can_manage_abilities}>
        {#each abilities as ability (ability.name)}
          <CheckboxField
            bind:checked={$form.admin.ability_names[ability.name]}
            label={ability.label}
            name={`ability_${ability.name}`}
            disabled={!can_manage_abilities}
          />
        {/each}
      </div>
    </FormSection>

    {#snippet footer()}
      <Button href="/admins" variant="ghost" size="sm">Cancel</Button>
      <SubmitButton processing={$form.processing} label="Invite" loadingLabel="Inviting…" full={false} />
    {/snippet}
  </FormLayout>
</Layout>
